var React = require('react');

function Webdevelopment (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"48","height":"48","rx":"14","fill":"#2C452B","key":0}),React.createElement("path",{"d":"M18 20.5664L15 23.9999L18 27.4333","stroke":"#5BA655","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M30.3333 20.5664L33.3333 23.9999L30.3333 27.4333","stroke":"#5BA655","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M25.8332 20L22.1665 28","stroke":"#5BA655","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Webdevelopment.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Webdevelopment;

Webdevelopment.default = Webdevelopment;
